import * as React from "react";
import classnames from "classnames";
import { DualColumnDropdown, SingleColumnDropdown } from "@grandvisionhq/forms";
import { useIntl } from "@grandvisionhq/state";
import { PrescriptionValueUtils, isNumber } from "@grandvisionhq/utils";
import { isPrescriptionValue } from "../../../../../../../../state/state/types.js";
import { usePrescriptionFormInput } from "../../../../../../context/steps/PrescriptionFormStep/context/PrescriptionFormInputContext.js";
/* empty css                                 */
const PLACEHOLDER = "---";
const getOptions = (values, prescriptionAttribute) => {
  const formatter = PrescriptionValueUtils.getFormatter(prescriptionAttribute);
  return Array.from(values).reduce((acc, value) => {
    const formattedValue = formatter(value);
    if (formattedValue) {
      return {
        ...acc,
        [formattedValue]: value
      };
    } else {
      console.error(
        `Error formatting prescription value ${value} for attribute: ${prescriptionAttribute}`
      );
      return acc;
    }
  }, {});
};
const PrescriptionFormInputSelect = () => {
  const {
    name,
    selectId,
    selectName,
    isValid,
    isFirstItem,
    isLastItem,
    values,
    value,
    onChange,
    required,
    side
  } = usePrescriptionFormInput();
  const { getLabel } = useIntl();
  const options = React.useMemo(
    () => getOptions(values, name),
    [values, name]
  );
  const hasNegativeValues = React.useMemo(
    () => Object.values(options).some((value2) => value2 < 0),
    [options]
  );
  const formattedValue = PrescriptionValueUtils.formatPrescriptionValue(name, value) ?? "";
  const isInvalid = isValid === false;
  const selectedValue = React.useMemo(
    () => isPrescriptionValue(value) && values.has(value) ? formattedValue : void 0,
    [values, value, formattedValue]
  );
  const fieldOptions = React.useMemo(() => {
    if (!required) {
      options[PLACEHOLDER] = PLACEHOLDER;
    }
    return options;
  }, [options, required]);
  const handleChange = React.useCallback(
    (newValue) => {
      if (isNumber(newValue)) {
        onChange(name, newValue);
      } else if (newValue === PLACEHOLDER) {
        onChange(name, void 0);
      }
    },
    [onChange, name]
  );
  if (hasNegativeValues) {
    return /* @__PURE__ */ React.createElement(
      DualColumnDropdown,
      {
        className: classnames("prescription-form-input-select", {
          "prescription-form-input-select--first": isFirstItem,
          "prescription-form-input-select--last": isLastItem
        }),
        label: `${getLabel(`products.glasses.prescription.${name}`)} ${getLabel(
          `products.glasses.${side}Eye`
        )}`,
        options: fieldOptions,
        selectedValue,
        onChange: handleChange,
        isInvalid,
        isRequired: required,
        "data-t": selectName,
        id: selectId
      }
    );
  }
  return /* @__PURE__ */ React.createElement(
    SingleColumnDropdown,
    {
      className: classnames("prescription-form-input-select", {
        "prescription-form-input-select--first": isFirstItem,
        "prescription-form-input-select--last": isLastItem
      }),
      isInvalid,
      isRequired: required,
      selectedValue,
      options: fieldOptions,
      id: selectId,
      onChange: handleChange,
      label: `${getLabel(`products.glasses.prescription.${name}`)} ${getLabel(
        `products.glasses.${side}Eye`
      )}`,
      "data-t": selectName
    }
  );
};
export {
  PrescriptionFormInputSelect
};
//# sourceMappingURL=PrescriptionFormInputSelect.js.map
